import React from 'react';
import { Amplify } from 'aws-amplify';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import awsconfig from './aws-exports';
import './App.css';
import logo from './cl_logo.png';  // Assuming you have this logo

Amplify.configure(awsconfig);

const apiUrl = process.env.REACT_APP_API_URL;

class SessionsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sessions: [],
            selectedSessions: [],
            loading: false,
            showModal: false,
            sessionToTerminate: null
        };
    }
// Fetch Sessions from API
fetchSessions = async () => {
    this.setState({ loading: true });
    try {
        const idToken = sessionStorage.getItem('idToken');
        //console.log("ID Token:", idToken);  // Add logging for debugging

        if (!idToken) {
            toast.error('No ID Token found.');
            this.setState({ loading: false });
            return;
        }

        const response = await axios.get(`${apiUrl}/sessions`, {
            headers: { 'Authorization': `Bearer ${idToken}` }
        });

        if (response.data.length === 0) {
            toast.info('No active sessions found.');
        } else {
            toast.success('Sessions loaded successfully.');
        }

        this.setState({ sessions: response.data, loading: false });
    } catch (error) {
        toast.error('Error fetching sessions.');
        this.setState({ loading: false });
    }
};

// Handle radio selection
handleRadioChange = (event) => {
    const { value } = event.target;
    this.setState({ selectedSessions: [value] });
};

// Trigger modal to confirm termination
confirmTerminateSession = () => {
    const { selectedSessions, sessions } = this.state;
    if (selectedSessions.length === 0) {
        toast.warning('Please select a session to terminate.');
        return;
    }

    const sessionToTerminate = sessions.find(session => session.Id === selectedSessions[0]);
    this.setState({ sessionToTerminate, showModal: true });
};

// Handle session termination (from old working code)
handleConfirmTermination = async () => {
    const { selectedSessions } = this.state;
    try {
        const idToken = sessionStorage.getItem('idToken');
        console.log("ID Token:", idToken);  // Add logging for debugging

        if (!idToken) {
            toast.error('No ID Token found.');
            return;
        }

        await Promise.all(
            selectedSessions.map(sessionId =>
                axios.post(`${apiUrl}/sessions`, { sessionId }, {  // Revert URL to /sessions
                    headers: { 'Authorization': `Bearer ${idToken}` }
                })
            )
        );

        this.fetchSessions();  // Re-fetch sessions after termination
        toast.success('Session terminated successfully.');
        this.setState({ showModal: false, selectedSessions: [] });
    } catch (error) {
        console.error('Error terminating session:', error);  // Log error for debugging
        toast.error('Error terminating session.');
    }
};

// Close the modal without terminating the session
handleCloseModal = () => {
    this.setState({ showModal: false });
};


    // Sign out the user
    signOut = () => {
        const { domain, redirectSignOut } = awsconfig.Auth.Cognito.loginWith.oauth;
        const clientId = awsconfig.Auth.Cognito.userPoolWebClientId;
        const signOutUrl = `https://${domain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(redirectSignOut)}`;
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('idToken');
        window.location.href = signOutUrl;
    };

    render() {
        const { loading, sessions, showModal, sessionToTerminate } = this.state;

        return (
            <div className="App">
                <header className="App-header">
                    <h1>Sessions Manager</h1>
                    <button className="btn primary" onClick={this.fetchSessions}>Load Sessions</button>
                    {loading ? (
                        <div className="loading-overlay">
                            <div className="loader"></div>
                        </div>
                    ) : (
                        <>
                            {sessions.length === 0 ? (
                                <p>No sessions available.</p>
                            ) : (
                                <form id="sessionsForm">
                                    <div className="table-container">
                                        <table className="sessions-table modern-table">
                                            <thead>
                                                <tr>
                                                    <th>Select</th>
                                                    <th>Session ID</th>
                                                    <th>User ID</th>
                                                    <th>State</th>
                                                    <th>Connection State</th>
                                                    <th>Start Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {sessions.map(session => (
                                                    <tr key={session.Id}>
                                                        <td>
                                                            <input
                                                                type="radio"
                                                                name="session"
                                                                value={session.Id}
                                                                onChange={this.handleRadioChange}
                                                                checked={this.state.selectedSessions.includes(session.Id)}
                                                            />
                                                        </td>
                                                        <td>{session.Id}</td>
                                                        <td>{session.UserId}</td>
                                                        <td>{session.State}</td>
                                                        <td>{session.ConnectionState}</td>
                                                        <td>{new Date(session.StartTime).toLocaleString()}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <button
                                        className="btn secondary"
                                        type="button"
                                        onClick={this.confirmTerminateSession}
                                        disabled={this.state.selectedSessions.length === 0}
                                    >
                                        Terminate Selected Session
                                    </button>
                                </form>
                            )}
                        </>
                    )}
                    <UserMenu signOut={this.signOut} />
                    {showModal && (
                        <ConfirmationModal
                            show={showModal}
                            handleClose={this.handleCloseModal}
                            handleConfirm={this.handleConfirmTermination}
                            sessionToTerminate={sessionToTerminate}
                        />
                    )}
                    <ToastContainer position="bottom-right" autoClose={3000} />
                </header>
            </div>
        );
    }
}

// ConfirmationModal Component
const ConfirmationModal = ({ show, handleClose, handleConfirm, sessionToTerminate }) => {
    if (!show) return null;

    return (
        <div className="modal">
            <div className="modal-content">
                <h3>Confirm Session Termination</h3>
                <p>Are you sure you want to terminate the following session?</p>
                <ul>
                    <li><strong>User ID:</strong> {sessionToTerminate.UserId}</li>
                    <li><strong>State:</strong> {sessionToTerminate.State}</li>
                    <li><strong>Connection State:</strong> {sessionToTerminate.ConnectionState}</li>
                    <li><strong>Start Time:</strong> {new Date(sessionToTerminate.StartTime).toLocaleString()}</li>
                </ul>
                <button className="btn secondary" onClick={handleClose}>Cancel</button>
                <button className="btn danger" onClick={handleConfirm}>Terminate</button>
            </div>
        </div>
    );
};

// UserMenu Component (unchanged)
class UserMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showDropdown: false,
            userName: '',
        };
        this.dropdownRef = React.createRef();
    }

    componentDidMount() {
        const idToken = sessionStorage.getItem('idToken');
        if (idToken) {
            const decodedToken = JSON.parse(atob(idToken.split('.')[1])); // Decode the JWT token
            let userName = decodedToken['cognito:username'] || decodedToken.email;

            if (userName.startsWith('entraid_')) {
                userName = userName.replace('entraid_', '');
            }

            this.setState({ userName });
            document.addEventListener('click', this.handleOutsideClick, true);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick, true);
    }

    toggleDropdown = (event) => {
        event.stopPropagation();
        this.setState((prevState) => ({
            showDropdown: !prevState.showDropdown,
        }));
    };

    handleOutsideClick = (event) => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({ showDropdown: false });
        }
    };

    render() {
        const { showDropdown, userName } = this.state;
        const { signOut } = this.props;

        return (
            <div className="user-menu" ref={this.dropdownRef}>
                <div className="user-avatar" onClick={this.toggleDropdown}>
                    <span>{userName.charAt(0).toUpperCase()}</span>
                </div>
                {showDropdown && (
                    <div className="user-dropdown">
                        <p>{userName}</p>
                        <button className="btn danger" onClick={signOut}>
                            Sign Out
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

// App Component
class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = { user: null };
    }

    componentDidMount() {
        if (window.location.hash) {
            this.fetchTokens();
        } else {
            const accessToken = sessionStorage.getItem('accessToken');
            if (accessToken) {
                this.setState({ user: { accessToken } });
            }
        }
    }

    fetchTokens = () => {
        const hash = window.location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const accessToken = params.get('access_token');
        const idToken = params.get('id_token');

        if (accessToken && idToken) {
            sessionStorage.setItem('accessToken', accessToken);
            sessionStorage.setItem('idToken', idToken);

            this.setState({ user: { accessToken, idToken } });
            window.location.hash = '';
            window.location.href = '/sessions';
        } else {
            console.error('Tokens are missing from the URL.');
        }
    };

    signIn = () => {
        const { domain, responseType, redirectSignIn } = awsconfig.Auth.Cognito.loginWith.oauth;
        const clientId = awsconfig.Auth.Cognito.userPoolWebClientId;
        const authUrl = `https://${domain}/oauth2/authorize?client_id=${clientId}&response_type=${responseType}&scope=email+openid+profile&redirect_uri=${encodeURIComponent(redirectSignIn)}`;
        window.location.href = authUrl;
    };

    render() {
        return (
            <div className="App_logo">
                {!this.state.user ? (
                    <div className="login-container">
                        <div className="login-box">
                            <img src={logo} alt="logo" className="login-logo" />
                            <h1>AppStream Session Manager</h1>
                            <p>Please log in to access your sessions</p>
                            <button className="btn primary" onClick={this.signIn}>Sign In</button>
                        </div>
                    </div>
                ) : (
                    <Routes>
                        <Route path="/sessions" element={<SessionsPage />} />
                    </Routes>
                )}
            </div>
        );
    }
}

const WrappedApp = () => (
    <Router>
        <App />
    </Router>
);

export default WrappedApp;
